import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isSafeReturnPath, setReturnPath } from '../returnPath';

function RequireAuth({ isAuthenticated, children }) {
  const location = useLocation();

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search || ''}`;
    if (isSafeReturnPath(returnTo)) {
      setReturnPath(returnTo);
    }
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default RequireAuth;
